import { Component, OnInit } from '@angular/core';
import { waitForAsync } from '@angular/core/testing';
import { Router } from '@angular/router';
import {
  AlertController,
  MenuController,
  ModalController,
  NavController,
  PopoverController,
} from '@ionic/angular';
import { CompanyService } from 'src/app/service/company/company.service';
import { ConfigServiceService } from 'src/app/service/config-service.service';
import { ElasticsearchService } from 'src/app/service/elasticsearch/elasticsearch.service';
import { HeaderFooterService } from 'src/app/service/headerFooter/header-footer.service';
import { DatabaseServiceService } from 'src/app/service/database-service.service';

import { environment } from '../../../environments/environment';
@Component({
  standalone: false,
  selector: 'app-show-dna',
  templateUrl: './show-dna.component.html',
  styleUrls: ['./show-dna.component.scss'],
})
export class ShowDNAComponent implements OnInit {
  public excludeParameters;
  public kgPricing;
  public index = environment.INDEX;
  public perPage = environment.RESULTS_PER_PAGE;
  qry;
  foundStones = [];
  public stoneId: any;
  searchedStone;

  constructor(
    public _companyService: CompanyService,
    public _headerFooterService: HeaderFooterService,
    public navCtrl: NavController,
    public _configService: ConfigServiceService,
    private router: Router,
    private menu: MenuController,
    public alertController: AlertController,
    private modalCtrl: ModalController,
    public popoverController: PopoverController,
    private es: ElasticsearchService,
    private databaseServiceService: DatabaseServiceService
  ) {}

  ngOnInit() {
    this.loadCompanyData();
    this.qry = {
      query: {
        match: {
          stoneName: '',
        },
      },
      //"_source": ["stoneName", "lab", "ShapeCode", "cts", "ColorCode", "ClarityCode", "CutCode", "PolishCode", "SymmetryCode", "FluorescenceCode", "Rapnet_plusDiscountPercent", "Rapnet_pluspercarat", "Rapnet_plus", "RAPAPORTpercarat", "externalStatus"]
    };
  }

  async loadCompanyData() {
    if (this._companyService.companyObj && this._companyService.companyObj) {
      if (this._companyService.companyObj.config) {
        let companyJson = this._companyService.companyObj.config;
        if (!!companyJson.externalProduct) {
          this.excludeParameters =
            companyJson.externalProduct.excludeParameters;
        }

        if (!!companyJson.externalProduct.kgAppliedPrice) {
          this.kgPricing = companyJson.externalProduct.kgAppliedPrice;
        }
      }
    }
  }

  closeModal() {
    this.popoverController.dismiss();
  }

  show(id?) {
    const sId = (id || this.stoneId).trim().toUpperCase();
    console.log(sId);
    this.qry.query.match.stoneName = sId;
    this.search(this.qry, 0, sId);
  }

  algolia(loadOption: any) {
    let wildcard = {},
      must_not = {},
      search = '';
    let indivisualFilter = [],
      searchFilter = '',
      loadOptions: any = loadOption.filter;
    if (!!loadOption.filter) {
      let options: any = loadOptions;
      if (
        loadOptions[1] == 'and' &&
        Array.isArray(options[0]) &&
        Array.isArray(options[2]) &&
        (options[0][1] == 'or' || options[2][1] == 'or')
      ) {
        let first: any = options[0]
          .map(keys => Array.isArray(keys) && keys[2])
          .filter(res => !!res)
          .filter((v, i, a) => a.indexOf(v) === i);
        let secound: any = options[2]
          .map(keys => Array.isArray(keys) && keys[2])
          .filter(res => !!res)
          .filter((v, i, a) => a.indexOf(v) === i);
        if (first.length == 1) {
          searchFilter = first[0];
          indivisualFilter = options[2];
        } else if (secound.length == 1) {
          searchFilter = secound[0];
          indivisualFilter = options[0];
        } else {
          // console.log("======something Wrong ====");
        }
      } else if (!Array.isArray(loadOption.filter[0])) {
        indivisualFilter = [loadOption.filter];
      } else {
        let first: any = options
          .map(keys => Array.isArray(keys) && keys[2])
          .filter(res => !!res)
          .filter((v, i, a) => a.indexOf(v) === i);
        if (first.length == 1) {
          searchFilter = first[0];
        } else {
          indivisualFilter = options;
        }
      }
      if (indivisualFilter.length > 0) {
        indivisualFilter.filter(loadOption => {
          if (loadOption.length > 0) {
            switch (loadOption[1]) {
              case 'contains':
                wildcard[loadOption[0]] = '*' + loadOption[2] + '*';
                break;
              case 'notcontains':
                must_not[loadOption[0]] = '*' + loadOption[2] + '*';
                break;
              case 'startswith':
                wildcard[loadOption[0]] = loadOption[2] + '*';
                break;
              case 'endswith':
                wildcard[loadOption[0]] = '*' + loadOption[2];
                break;
              case '=':
                wildcard[loadOption[0]] = loadOption[2];
                break;
              case '<>':
                must_not[loadOption[0]] = loadOption[2];
                break;
              default:
                break;
            }
          }
        });
      }
      if (searchFilter.length > 0) {
        search = '*' + searchFilter + '*';
      }
    }
    return { wildcard, must_not, search };
  }

  async search(query, from, targetId?) {
    const sId = targetId || this.stoneId;
    try {
      await this._configService.showLoading();

      const searchPayload = {
        query: JSON.stringify(query),
        from: from,
        size: this.perPage,
      };
      const searchRes: any = await this.databaseServiceService.querySearchResults(searchPayload);
      await this._configService.hideLoading();
      const body = searchRes?.data?.body;

      if (body?.hits?.total?.value > 0) {
        const data = body.hits.hits;
        this.foundStones = data.map(d => d._source);

        // If the stone is sold, search by kgStoneId to find it at its actual location
         if (this.foundStones[0].internalStatus === 'Sold') {
          await this._configService.showLoading();
          const kgQuery = {
            query: {
              match: {
                kgStoneId: this.stoneId,
              },
            },
          };
          const kgPayload = {
            query: JSON.stringify(kgQuery),
            from: 0,
            size: 1,
          };
          const kgRes: any = await this.databaseServiceService.querySearchResults(kgPayload);
          await this._configService.hideLoading();
          const kgBody = kgRes?.data?.body;

          if (kgBody?.hits?.total?.value > 0) {
            const kgStone = kgBody.hits.hits[0]._source;
            const safeLow = (val: any) => String(val || '').toLowerCase();
            const mapped = this._configService.locationsArray.find(
              l => safeLow(l.value) === safeLow(kgStone.currentLocation)
            );

            this.popoverController.dismiss({
              stoneName: kgStone.stoneName,
              location: mapped ? mapped.id : kgStone.currentLocation,
            });
            return;
          }
        }

        let locationId = this.determineLocation(this.foundStones);
        if (locationId) {
          const stoneObj = {
            stoneName: sId,
            location: locationId,
          };
          this.popoverController.dismiss(stoneObj);
        } else {
          this.handleNavigation(sId);
        }
      } else {
        this.handleNavigation(sId);
      }
    } catch (error) {
      await this._configService.hideLoading();
      console.error('Error during search:', error);
    }
  }

  determineLocation(stones) {
    if (!stones || stones.length === 0) return null;

    const safeLow = (val: any) => String(val || '').toLowerCase();

    // Prioritize available stones
    const availableStones = stones.filter(s => s.availableForSale);
    let workingStones = availableStones.length > 0 ? availableStones : stones;

    if (workingStones.length === 1) {
      const loc = workingStones[0].currentLocation;
      const mapped = this._configService.locationsArray.find(l => safeLow(l.value) === safeLow(loc));
      return mapped ? mapped.id : loc;
    }

    let filteredStones = [...workingStones];

    // Rule 5: If stone is on Consignment in Mumbai and memo in other location → remove Mumbai stone.
    const hasMumbaiConsignment = workingStones.some(
      s =>
        safeLow(s.currentLocation) === 'mumbai' &&
        safeLow(s.externalStatus) === 'consignment'
    );
    const hasOtherMemo = workingStones.some(
      s =>
        safeLow(s.currentLocation) !== 'mumbai' &&
        safeLow(s.externalStatus) === 'on memo'
    );

    if (hasMumbaiConsignment && hasOtherMemo) {
      filteredStones = filteredStones.filter(
        s =>
          !(
            safeLow(s.currentLocation) === 'mumbai' &&
            safeLow(s.externalStatus) === 'consignment'
          )
      );
    }

    // Rule 3: If stone is on memo in multiple locations (Non Mumbai):
    // If Memo Type = Group Company → remove it, Memo Type = third-party → keep stone
    const nonMumbaiMemos = filteredStones.filter(
      s =>
        safeLow(s.currentLocation) !== 'mumbai' &&
        safeLow(s.externalStatus) === 'on memo'
    );
    if (nonMumbaiMemos.length > 1) {
      const thirdPartyMemos = nonMumbaiMemos.filter(
        s => safeLow(s.memoType) === 'third-party'
      );
      if (thirdPartyMemos.length > 0) {
        filteredStones = filteredStones.filter(
          s =>
            safeLow(s.currentLocation) === 'mumbai' ||
            safeLow(s.externalStatus) !== 'on memo' ||
            safeLow(s.memoType) !== 'group company'
        );
      } else {
        filteredStones = filteredStones.filter(
          s =>
            safeLow(s.currentLocation) === 'mumbai' ||
            safeLow(s.externalStatus) !== 'on memo' ||
            safeLow(s.memoType) !== 'group company'
        );
      }
    }

    if (filteredStones.length === 0) filteredStones = workingStones;

    // Sort by location priority
    const priority = ['mumbai', 'aspecony', 'ny', 'hk', 'dmcc', 'aspeconv'];
    filteredStones.sort((a, b) => {
      let indexA = priority.indexOf(safeLow(a.currentLocation));
      let indexB = priority.indexOf(safeLow(b.currentLocation));

      if (indexA === -1) indexA = 999;
      if (indexB === -1) indexB = 999;

      return indexA - indexB;
    });

    const selectedLoc = filteredStones[0].currentLocation;
    const mappedLoc = this._configService.locationsArray.find(l => safeLow(l.value) === safeLow(selectedLoc));
    return mappedLoc ? mappedLoc.id : selectedLoc;
  }

  handleNavigation(sId?) {
    const targetId = sId || this.stoneId;
    this.popoverController.dismiss();
    this.navCtrl.navigateForward(['/' + this.stoneId]);
  }

  omit_special_char(event) {
    console.log(event.target.value);
    if (event.target.value) {
      let str = event.target.value.split('\n');
      console.log(str.length);
      for (let i = 0; i < str.length; i++) {
        console.log(str[i]);
        let stoneId = str[i];
        if (stoneId.length > 20) {
          return false;
        }
      }
    }
    var k;
    k = event.charCode; //         k = event.keyCode;  (Both can be used)
    return (
      (k > 64 && k < 91) ||
      (k > 96 && k < 123) ||
      k == 8 ||
      k == 110 ||
      k == 13 ||
      k == 32 ||
      (k >= 48 && k <= 57) ||
      k == 45
    );
  }
}
